import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    alreadyConnected: {
      textAlign: 'center',
      color: COLORS.gray.gray30,
    },
    noAccountsCell: {
      backgroundColor: COLORS.warning.light,
    },
    textEmpty: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      columnGap: theme.spacing(0.5),
      color: COLORS.gray.black,
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    unauthorizedText: {
      textAlign: 'center',
      color: COLORS.gray.gray30,
    },
  }),
  { name: 'EmptyStateRow' }
);
